import React from 'react';

function Missing() {
  return (
    <h1>404 - Nothing to see here pal</h1>
  )
}

export default Missing